import BackButtonToolbar from "features/BackButtonToolbar";
import React from "react";
import { Edit, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";

const EditActivityForeignLanguages = () => {
  return (
    <Edit
      title="Редактиране на чужд език"
      actions={<BackButtonToolbar />}
      mutationMode="pessimistic"
    >
      <SimpleForm>
        <SaveForm />
      </SimpleForm>
    </Edit>
  );
};

export default EditActivityForeignLanguages;
